import { useParams } from 'react-router-dom';
import { useSearchParams } from 'logic/hooks/use-search-params';

export const useDecodedSubjectFromURI = () => {
  const { subject: subjectParam } = useParams<{ subject: string }>();
  const searchParams = useSearchParams();
  const subjectSearchParam = searchParams.get('subject');

  return decodeURIComponent(subjectParam || subjectSearchParam || '');
};
